(() => {
  const BLOCK_SELECTOR = '[class*="_pdp_info_block"][class*="ss_product_vidoes"]';
  const MODAL_SELECTOR = '[class*="video-modal-"][class*="ss_product_vidoes"]';
  const TARGET_HEIGHT = 480;
  const RENDITION_PATTERN = /^(.+?)\.((?:HD|SD)-(\d+)p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const manifests = new Map();
  const handled = new WeakSet();

  const toAbsolute = (url) => new URL(url, window.location.href);

  const findRendition = (originalSrc) => {
    const original = toAbsolute(originalSrc);
    const folder = original.pathname.slice(0, original.pathname.lastIndexOf('/') + 1);
    const videoId = original.pathname.slice(folder.length).split('.')[0];
    const manifestUrl = `${original.origin}${folder}${videoId}.m3u8`;

    if (!manifests.has(manifestUrl)) {
      manifests.set(
        manifestUrl,
        fetch(manifestUrl)
          .then((response) => (response.ok ? response.text() : ''))
          .catch(() => '')
      );
    }

    return manifests.get(manifestUrl).then((manifest) => {
      const renditions = manifest
        .split('\n')
        .map((line) => line.trim().match(RENDITION_PATTERN))
        .filter(Boolean)
        .map((match) => ({
          height: parseInt(match[3], 10),
          url: `${original.origin}${folder}${match[1]}.${match[2]}-${match[4]}-${match[5]}.mp4`,
        }))
        .filter((rendition) => rendition.height >= TARGET_HEIGHT)
        .sort((first, second) => first.height - second.height);

      return renditions.length ? renditions[0].url : original.href;
    });
  };

  const takeOver = (video) => {
    if (handled.has(video) || !video.closest(BLOCK_SELECTOR)) return;
    const originalSrc = video.getAttribute('src') || video.dataset.pdpSocialSrc;
    if (!originalSrc) return;
    handled.add(video);
    video.dataset.pdpSocialSrc = originalSrc;

    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.muted = true;
    video.removeAttribute('src');
    video.load();

    let visible = false;
    let chosenSrc = null;

    const sync = () => {
      if (!chosenSrc) return;
      if (visible && !reduceMotion.matches && !document.hidden) {
        if (!video.getAttribute('src')) video.src = chosenSrc;
        const playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(() => {});
      } else {
        video.pause();
      }
    };

    video.addEventListener(
      'error',
      () => {
        if (!chosenSrc || chosenSrc === toAbsolute(originalSrc).href) return;
        chosenSrc = toAbsolute(originalSrc).href;
        video.src = chosenSrc;
        sync();
      },
      { once: true }
    );

    findRendition(originalSrc).then((url) => {
      chosenSrc = url;
      sync();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => {
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          sync();
        },
        { threshold: [0, 0.5, 1] }
      ).observe(video);
    } else {
      visible = true;
      sync();
    }

    document.addEventListener('visibilitychange', sync);
  };

  const parkModalVideo = (video) => {
    if (!video.closest(MODAL_SELECTOR) || !video.dataset.src) return;
    video.dataset.pdpModalSrc = video.dataset.src;
    video.removeAttribute('data-src');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
  };

  const restoreModalVideos = () => {
    document.querySelectorAll(`${MODAL_SELECTOR} video[data-pdp-modal-src]`).forEach((video) => {
      if (!video.getAttribute('src')) video.src = video.dataset.pdpModalSrc;
    });
  };

  const handleVideo = (video) => {
    takeOver(video);
    parkModalVideo(video);
  };

  const scan = (node) => {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'VIDEO') {
      handleVideo(node);
      return;
    }
    node.querySelectorAll('video').forEach(handleVideo);
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest && event.target.closest(BLOCK_SELECTOR)) restoreModalVideos();
    },
    true
  );

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(scan));
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.querySelectorAll('video').forEach(handleVideo);
})();
